import { toast } from '../state/store';

export function Toast() {
  const current = toast.value;
  if (!current) return null;
  return (
    <div class={`toast ${current.kind}`} role="status" aria-live="polite">
      {current.text}
    </div>
  );
}
